import { useEffect, useState } from 'react';

const IDS = ['home', 'apps', 'studio', 'contact'];

// Tracks which Home section (#home/#apps/#studio/#contact) is currently
// centered in the viewport, so Nav/TabBar can highlight the right tab while
// the user free-scrolls instead of only reacting to URL changes.
export function useHomeScrollSpy(enabled) {
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setActive(null);
      return;
    }
    const els = IDS.map((id) => document.getElementById(id)).filter(Boolean);
    if (!els.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: '-45% 0px -50% 0px', threshold: 0 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [enabled]);

  return active;
}
